import $ from 'jquery';
import 'slick-carousel';

export const init = ($target) => {
	
		$target.find('.crosselling-swiper').each(function () {
			const el = this;
			// Pokud u� Swiper b��, nepou�t�t znovu
			if (el.swiper) return;

			new Swiper(el, {
				direction: 'horizontal',
				loop: true,
				slidesPerView: 1,
				slidesToScroll: 1,
				pagination: {
					el: $(el).find('.swiper-pagination')[0],
				},
				navigation: {
					nextEl: $(el).closest('#crossselling-products').find('.swiper-button-next')[0],
					prevEl: $(el).closest('#crossselling-products').find('.swiper-button-prev')[0],
				},
				breakpoints: {
					480: {
						slidesPerView: 2,
					},
					750: {
						slidesPerView: 3,
					}
				}
			});
		});

	$target.find('.c-products--carousel').each(function() {
		var $this = $(this),
			$scroll = $this.find('.c-products__scroll'),
			$next = $this.find('.c-products__next'),
			$prev = $this.find('.c-products__prev');

		$scroll.slick({
			arrow: true,
			dots: true,
			speed: 500,
			slidesToShow: 4,
			slidesToScroll: 2,
			infinite: true,
			prevArrow: $target.find( $prev ),
			nextArrow: $target.find( $next ),
			responsive:
			[
				{
					breakpoint: 1000,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						infinite: true,
						dots: true,
					},
				},
				{
					breakpoint: 750,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						infinitie: true,
						dots: true,
					},
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						dots: true,
					},
				},
			],
		});
	}).on('breakpoint', function() {
		$(this).find('.icon-svg').each(function () {
			const svg = $(this).find('> svg').detach();
			setTimeout(() => {
				svg.appendTo(this);
			}, 0);
		});
	});


	$target.find('.c-promo--carousel').each(function() {
		var $this = $(this),
			$scroll = $this.find('.c-promo__list'),
			$menuItems = $this.find('.c-promo__menu .m-side__item'),
			$progressBar = $this.find('.c-promo__progress-inner'),
			$menuArrow = $this.find('.m-side__arrow'),
			$menuList = $this.find('.m-side__list'),
			time = 5000;

		$scroll
			.slick({
				arrow: false,
				dots: false,
				prevArrow: false,
				nextArrow: false,
				speed: 600,
				slidesToShow: 1,
				slidesToScroll: 1,
				responsive:
				[
					{
						breakpoint: 1000,
						settings: {
							dots: true,
						},
					},
				],
			})
			.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				$menuItems
					.removeClass('is-active')
					.eq( nextSlide ).addClass('is-active');

				var activeItemOffset = $menuItems.eq(nextSlide).offset().top - $menuList.offset().top ;
				setArrowPosition(activeItemOffset);
				resetProgressbar();

			})
			.on('afterChange', function(event, slick, currentSlide) {
				startProgressbar();
			});

		$menuItems
			.on('click', function(e) {
				e.preventDefault();
				$scroll.slick('slickGoTo', $(this).index(), function() {
					startProgressbar();
				});
			});

		startProgressbar();

		function setArrowPosition(offset) {
			$menuArrow.css('transform', 'translateY(' + offset + 'px)');
		}
		function startProgressbar() {
			resetProgressbar();
			$progressBar.animate({ width: '100%' }, time, 'linear', function() {
				$scroll.slick('slickNext');
			});
		}

		function resetProgressbar() {
			$progressBar.stop().css('width', 0 + '%');
		}
	});
};
